import { Box, Button, Typography } from '@mui/material';
import ButtonGroup from 'components/button-group';
import Dialog from 'components/dialog';
import InfoBox from 'components/info-box';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TemperatureProfileInformation } from 'views/bluviu-nutrition/features/calibrations/types/temperature-profile-information.type';
import ViewTemperatureChart from './view-temperature-chart';
import ViewTemperatureTable from './view-temperature-table';

type Props = {
  temperatureProfile: TemperatureProfileInformation[];
};

const ViewTemperatureProfile: React.FC<Props> = ({ temperatureProfile }) => {
  const PAGE_NAME_ID = `bluViuNutrition.calibrations.editCalibration.temperatureLocation.temperatureProfile`;
  const intl = useIntl();
  const [showTable, setShowTable] = useState<boolean>(false);

  return (
    <Dialog
      title={intl.formatMessage({ id: `${PAGE_NAME_ID}.title` })}
      button={
        <Button disabled={!temperatureProfile?.length}>
          <FormattedMessage id={`${PAGE_NAME_ID}.dialogButton`} />
        </Button>
      }
      onClose={() => setShowTable(false)}
      maxWidth={'md'}>
      <Box display={'flex'} flexDirection={'column'} gap={4}>
        <Box display={'flex'} flexDirection={'column'}>
          <Box display={'flex'} flexDirection={'column'} justifyContent={'right'} alignItems={'center'} pb={4} gap={4}>
            <ButtonGroup
              value={'group'}
              buttons={[
                {
                  label: intl.formatMessage({ id: `${PAGE_NAME_ID}.buttonGroup.graph` }),
                  value: 'left',
                  state: false,
                },
                {
                  label: intl.formatMessage({ id: `${PAGE_NAME_ID}.buttonGroup.list` }),
                  value: 'right',
                  state: true,
                },
              ]}
              handleClick={(e) => setShowTable(e as boolean)}
            />
          </Box>
          <Typography variant="h4">
            <FormattedMessage id={`${PAGE_NAME_ID}.header`} />
          </Typography>
          <Box padding={4} overflow={'scroll'}>
            {!showTable ? (
              <ViewTemperatureChart temperatureProfile={temperatureProfile} />
            ) : (
              <ViewTemperatureTable temperatureProfile={temperatureProfile} />
            )}
          </Box>
        </Box>
        <InfoBox>
          <FormattedMessage id={`${PAGE_NAME_ID}.information`} />
        </InfoBox>
      </Box>
    </Dialog>
  );
};

export default React.memo(ViewTemperatureProfile);
